/**
 * CJ Owl Basic vs Premium feature matrix — drives the comparison chart on the
 * FeatureLock (locked-page) screen. A cell value of:
 *   true   → included (✔)
 *   false  → locked / not in this plan (🔒)
 *   string → included, with a short qualifier shown under the check (e.g. "Summary")
 */
export type PlanFeature = { name: string; basic: boolean | string; premium: boolean | string };

export const PLAN_FEATURES: PlanFeature[] = [
  { name: "Customer Dashboard",                basic: true,       premium: true },
  { name: "Household Profile",                 basic: true,       premium: true },
  { name: "1 Primary Property",                basic: true,       premium: true },
  { name: "Additional Properties",             basic: false,      premium: "Paid add-on" },
  { name: "DIY Service Setup",                 basic: true,       premium: true },
  { name: "Household Savings Review",          basic: "Summary",  premium: "Full expert report" },
  { name: "Smart Deals",                       basic: true,       premium: "Personalized" },
  { name: "Deal Watchlist",                    basic: true,       premium: true },
  { name: "Manual Subscription Tracker",       basic: true,       premium: true },
  { name: "Automatic Subscription Management", basic: false,      premium: true },
  { name: "Manual Renewal Reminders",          basic: true,       premium: true },
  { name: "Automatic Renewal Monitoring",      basic: false,      premium: true },
  { name: "Basic Document Vault",              basic: true,       premium: true },
  { name: "Unlimited Vault",                   basic: false,      premium: true },
  { name: "Savings Calculator",                basic: true,       premium: true },
  { name: "Educational Hub",                   basic: true,       premium: true },
  { name: "Value & Risk Guard™",               basic: false,      premium: true },
  { name: "Subscription Optimization",         basic: false,      premium: true },
  { name: "Contract Review™",                  basic: false,      premium: true },
  { name: "Second Opinion™",                   basic: false,      premium: true },
  { name: "Ask CJ™ AI",                        basic: false,      premium: true },
  { name: "Opportunity Explorer™",             basic: false,      premium: true },
  { name: "AI Bill Analysis™",                 basic: false,      premium: true },
  { name: "AI Research Engine™",               basic: false,      premium: true },
  { name: "Dedicated Savings Advisor",         basic: false,      premium: true },
  { name: "Household Health Score™",           basic: false,      premium: true },
  { name: "Annual Household Review™",          basic: false,      premium: true },
  { name: "Rewards & Referrals",               basic: false,      premium: true },
];
